module.exports = __webpack_public_path__ + "static/media/sel_18_276.7f83ca01.mp4";